import React from 'react';
import { StyledIonIcon } from './BackToProgIcon.styled';
import backToProgIcon from './back-to-prog.svg';

const BackToProgIcon = () => {
  return <StyledIonIcon src={backToProgIcon} />;
};

export default BackToProgIcon;
